/**
 * Anime les counters
 * @param $selectors
 * @param $speed
 */
const animatedCounter = ($selectors  = '.counter__number', $speed = 200) => {

    const $counters = document.querySelectorAll($selectors);
    if ($counters) {
        $counters.forEach($counter => {
            if($counter.getAttribute('data-target')) {
                const $target = +$counter.getAttribute('data-target');
                $counter.innerText = $target;
            }
        });
    }

};

const updateCount = ($counter) => {
    const $target = +$counter.getAttribute('data-target');
    const $count = +$counter.innerText;

    // Plus la cible est basse moins ira vite
    const $inc = $target / $speed;

    // Vérifie si on a atteind le compter
    if ($count < $target) {
        // Ajoute le counter
        $counter.innerText = Math.ceil($count + $inc);

        setTimeout(updateCount, 1);
    } else {
        $counter.innerText = $target;
    }
};

export default animatedCounter;

